webpackJsonp([192732707689645],{

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _HookTutorial = __webpack_require__(50);
	
	var _HookTutorial2 = _interopRequireDefault(_HookTutorial);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _HookTutorial2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 2: Generate the Hook'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'re going to generate the custom hook.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can view the finished code for this step by checking out the ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'step-2'
	        ),
	        ' branch.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Run the Generator'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The Lore CLI includes a number of commands that can generate files. Among them is a command that will generate starter code for a custom hook. Run this command to create a hook called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'polling-hook'
	      ),
	      ':'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore generate hook polling-hook\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This command will create a folder called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'polling-hook'
	      ),
	      ' at the root of your project, and place the starter code for a hook inside that folder. The structure should look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      polling-hook\n      |-- src\n      |   |--index.js\n      |-- test\n      |   |-- test.spec.js\n      |-- .babelrc\n      |-- package.json\n      |-- README.md\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add the Hook'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Now that we\'ve generated the hook, let\'s add it to the project so it gets loaded when the application boots up.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Open up ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'index.js'
	      ),
	      ' file at the root of your project and insert the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'polling-hook'
	      ),
	      ' into the list of hooks. Note that we\'re using a relative path, since the hook is located within our project and ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'not'
	      ),
	      ' installed as an npm module.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // index.js\n      import models from \'lore-hook-models\';\n      import polling from \'./polling-book/src\';\n      import reducers from \'lore-hook-reducers\';\n      ...\n      lore.summon({\n        hooks: {\n          ...\n          models,\n          polling,\n          reducers,\n          ...\n        }\n      });\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With this change in place, the hook will now be loaded as the application boots up. To prove that, open up the file ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'polling-hook/src/index.js'
	      ),
	      '. It currently it looks like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        module.exports = {\n\n          dependencies: [],\n\n          defaults: {},\n\n          load: function(lore) {\n            // do something\n          }\n\n        };\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        export default {\n\n          dependencies: [],\n\n          defaults: {},\n\n          load: (lore) => {\n            // do something\n          }\n\n        };\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        export default {\n\n          dependencies: [],\n\n          defaults: {},\n\n          load: (lore) => {\n            // do something\n          }\n\n        };\n        ' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Modify the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'load'
	      ),
	      ' function to look like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        ...\n          load: function(lore) {\n            console.log(\'polling-hook loading!\');\n          }\n        ...\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        ...\n          load: (lore) => {\n            console.log(\'polling-hook loading!\');\n          }\n        ...\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        ...\n          load: (lore) => {\n            console.log(\'polling-hook loading!\');\n          }\n        ...\n        ' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Now open the developer tools in the browser and refresh the page. If you examine the console, you should see the phrase ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'polling-hook loading!'
	      ),
	      ' printed out.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-3/' },
	        'specify our hook dependencies'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-tutorial-step-2-js-d088fb46711313e6ff62.js